export default __webpack_public_path__ + "static/media/id.30a5dddd.svg";